import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: palette['grey-50'],
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
  },
  logo: {
    marginTop: anatomy['space-20'],
    height: anatomy['space-16'],
    textAlign: 'center',
  },
  main: {
    padding: anatomy['space-64'],
    gap: anatomy['space-64'],
    height: '100%',
    width: 'max-content',
    margin: '0 auto',
    display: 'flex',
  },
  qr: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundImage: 'repeating-linear-gradient(180deg, #1d252d33, #1d252d33 8px, transparent 8px, transparent 16px)',
    backgroundPosition: 'right top',
    backgroundRepeat: 'repeat-y',
    backgroundSize: '1px 100%',
    width: {
      default: '360px',
      '@media (min-width: 1000px)': '500px',
      '@media (min-width: 1200px)': '656px',
    },
  },
  label: {
    color: palette['grey-500'],
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: '17px',
  },
  eventName: {
    fontFamily: fonts.din2014Demi,
    color: palette['grey-950'],
    fontSize: typography['fontSizeDisplay-2'],
    lineHeight: '80px',
    maxWidth: '94%',
  },
  categories: {
    marginRight: anatomy['space-24'],
    ':not(#__unused__) > div': {
      flexWrap: 'wrap',
    },
  },
  counter: {
    fontFamily: fonts.din2014Demi,
    color: palette['grey-950'],
    fontSize: typography['fontSizeHeading-3'],
    lineHeight: anatomy['space-36'],
    display: 'flex',
    gap: anatomy['space-20'],
    marginTop: anatomy['space-40'],
  },
  qrCode: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-12'],
    marginTop: 'auto',
  },
  qrDescription: {
    color: palette['grey-500'],
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    marginLeft: anatomy['space-16'],
  },
  guests: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-40'],
    maxWidth: '592px',
  },
  mainGuest: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-4'],
    color: palette['grey-950'],
    fontSize: typography['fontSizeHeading-2'],
    lineHeight: anatomy['space-40'],
  },
  additionalGuests: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-12'],
  },
  guestsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-8'],
    color: palette['grey-950'],
    fontSize: typography['fontSizeBody-2'],
    lineHeight: typography['lineHeightBody-2'],
  },
});
